import * as React from 'react';

import Alert from '../../../../libs/controls/components/Alert';

interface ModalAgreementProps {
  isChecked: boolean;
  isShowingError: boolean;
  onAcceptChange: (isChecked: boolean) => void;
}

export const ModalAgreement = ({
  isChecked,
  isShowingError,
  onAcceptChange,
}: ModalAgreementProps) => {
  return (
    <div className="form-group row">
      <div className="col-xs-12 control-label">
        <div className="reportbox-content-desc required">
          <a
            href="https://lk.uat.sk.ru/actualize/static/files/agreement.pdf"
            target="_blank"
            rel="noreferrer"
          >
            Согласие на обработку персональных данных
          </a>
        </div>
      </div>
      <div className="col-xs-12">
        <div className="input-group">
          <label className="checkset-inline">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => onAcceptChange(!isChecked)}
            />
            <span>Я согласен на обработку персональных данных</span>
          </label>
        </div>
        {isShowingError ? (
          <Alert>Поле обязательное для заполнения</Alert>
        ) : null}
      </div>
    </div>
  );
};
